import Vue from 'vue'
import Vuex from 'vuex'
import createLogger from 'vuex/dist/logger'

Vue.use(Vuex)

const state = {
  wechat: false,
  info: {}
}

const getters = {
}

const mutations = {
  setWechat(state, flag) {
    state.wechat = flag
  },
  setInfo(state, info) {
    state.info = info
  }
}

const debug = process.env.NODE_ENV !== 'production'

export default new Vuex.Store({
  getters,
  state,
  mutations,
  strict: debug,
  plugins: debug ? [createLogger()] : []
})
